var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"widget-tag ma-0 pa-2",attrs:{"flat":"","width":"100%","color":_vm.widget.bg_color}},[_c('v-sheet',{attrs:{"color":"transparent"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.widget.html_tag)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }